import { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { FullLoader } from "@/components/auth/RequireRole";

/** Option B: a participant scans the company stand QR (`/q/<token>`) with any camera app. */
export default function QrEmpresa() {
  const { token } = useParams();
  const [to, setTo] = useState(null);
  useEffect(() => {
    api.get(`/companies/by-qr/${encodeURIComponent(token)}`)
      .then((r) => setTo(`/empresas/${r.data.slug}?k=${encodeURIComponent(token)}`))
      .catch(() => setTo("/empresas?qr=invalid"));
  }, [token]);
  return to ? <Navigate to={to} replace /> : <FullLoader />;
}
